"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remToPxUnit = void 0;
var remToPxUnit = exports.remToPxUnit = function remToPxUnit(rem, baseFontSize) {
  var parts = rem.split("rem");
  return "".concat(parts[0] * baseFontSize);
};